import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import { compose } from 'utils/react';
import { Input } from 'containers/form';
import { resolveContentUrl } from '../../../../../modules/assets';
import { editModal, section } from '../decorators';
import styles from './SimpleHero.scss';

const SimpleHero = ({ children, heroImage }) => {
  const [title, bragging, button] = React.Children.toArray(children);

  const heroStyle = {
    background: [
      'linear-gradient(to bottom, rgba(40, 40, 40, .2), rgba(40, 40, 40, .8))',
      `url("${resolveContentUrl(
        heroImage.file || heroImage[0].file,
      )}") center center`,
    ].join(', '),
    backgroundSize: 'cover',
  };

  return (
    <Container fluid className={styles.simpleHero} style={heroStyle}>
      <Row>
        <Col xs={12} className={styles.imgHeight}>
          <div>
            <div className={styles.jumboHeader}>{title}</div>
            <div className={styles.bragging}>{bragging}</div>
            <div className={styles.buttonContainer}>
              {React.cloneElement(button, { invertColors: true })}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
SimpleHero.propTypes = {
  children: PropTypes.node.isRequired,
  heroImage: PropTypes.shape({
    file: PropTypes.string.isRequired,
    alt: PropTypes.string,
  }),
};

export default compose(
  editModal(
    {
      title: 'Hero Section',
    },
    [
      {
        children: (
          <Field
            component={Input.FileUpload}
            count={1}
            fileKey="hero-image"
            name="heroImage"
          />
        ),
      },
    ],
  ),
  section(
    {
      name: 'Simple Hero',
      category: 'Images',
      deprecated: true,
      defaultPayload: {
        heroImage: {
          alt: 'Hero Image',
          file: '/img/hero.jpg',
        },
      },
    },
    {
      subsections: [
        { accepts: ['HeaderText'] },
        { accepts: ['ContentBox', 'Video'] },
        { accepts: ['Button'] },
      ],
      defaults: [
        [
          'HeaderText',
          {
            rawContentState: {
              blocks: [
                {
                  key: 'db2mm',
                  text: 'Awesome Self Storage',
                  type: 'header-one',
                  depth: 0,
                  inlineStyleRanges: [],
                  entityRanges: [],
                },
              ],
              entityMap: {},
            },
          },
        ],
        [
          'ContentBox',
          {
            rawContentState: {
              blocks: [
                {
                  key: 'db2mm',
                  text: 'This is where you brag about how fantastic your place is',
                  type: 'unstyled',
                  depth: 0,
                  inlineStyleRanges: [],
                  entityRanges: [],
                },
              ],
              entityMap: {},
            },
          },
        ],
        ['Button', { text: 'Start Storing Today' }],
      ],
      menu: { items: ['edit', 'delete'] },
    },
  ),
)(SimpleHero);
